'use strict';

/*
DOCUMENT ME
*/

define('modules/module.camry.static',[
  'jquery',
  './module.static',
  'lib/util/tda.config'
], function (
  $,
  StaticModule,
  tdaConfig
) {
  var CamryStaticModule = StaticModule.extend({
    staticData: {
      /*
      TOYOTA CARS — ES: AUTOS TOYOTA
      The 2018 Corolla — ES: El Corolla 2018
      The 2018 Corolla is down for fun. — ES: Te divertirás con el Corolla 2018
      Learn More > (Link to Model Landing page) — ES: Ver más (link to ES vehicle info page)
      */
      all: {
        image: {
          '1x1': '/assets/img/module/vehicleInfo/2018/1_3_2018-corolla@2x.jpg',
          '2x1': '/assets/img/module/vehicleInfo/2018/1_3_2018-corolla@2x.jpg',
          '3x1': '/assets/img/module/vehicleInfo/2018/1_3_2018-corolla@2x.jpg'
        }
      },
      en: {
        subtext: 'Toyota Cars',
        headline: 'The 2018 <strong>Corolla</strong>',
        copy: {
          '1x1': '<p>The 2018 Corolla is down for fun.</p>',
          '2x1': '<p>The 2018 Corolla is down for fun.</p>',
          '3x1': '<p>The 2018 Corolla is down for fun.</p>',
        },
        actions: [
          {
            title: 'Learn More',
            url: '/' + tdaConfig.site.context_url + '/vehicles/corolla',
          }
        ],
        dataLayer: {
          'link_text': 'Learn More',
          'list_item_index': '2',
          'content_section': 'Get_Started',
          'series_code': 'Corolla',
          'series_year': '2018',
          'series_number': '',
          'series_vehicleid': '',
          'series_inventory_type': 'New',
          'series_brand': 'Toyota',
          'series_category': 'cars-n-minivans',
          'series_fuel_type': '',
          'series_msrp': '',
          'series_grade': '',
          'series_engine': '',
          'series_transmission': '',
          'series_body_style': '',
          'series_packages': '',
          'series_color_ext': '',
          'series_color_int': '',
          'series_color_ext_code': '',
          'series_color_int_code': '',
          'series_accessories_name': ''
        }
      },
      es: {
        subtext: 'Autos Toyota ',
        headline: 'El <strong>Corolla</strong> 2018',
        copy: {
          '1x1': '<p>Te divertirás con el Corolla 2018.</p>',
          '2x1': '<p>Te divertirás con el Corolla 2018.</p>',
          '3x1': '<p>Te divertirás con el Corolla 2018.</p>',
        },
        actions: [
          {
            title: 'Ver más',
            url: '/' + tdaConfig.site.context_url + '/vehicles/corolla',
          }
        ],
        dataLayer: {
          'link_text': 'Ver más',
          'list_item_index': '2',
          'content_section': 'Get_Started',
          'series_code': 'Corolla',
          'series_year': '2018',
          'series_number': '',
          'series_vehicleid': '',
          'series_inventory_type': 'New',
          'series_brand': 'Toyota',
          'series_category': 'cars-n-minivans',
          'series_fuel_type': '',
          'series_msrp': '',
          'series_grade': '',
          'series_engine': '',
          'series_transmission': '',
          'series_body_style': '',
          'series_packages': '',
          'series_color_ext': '',
          'series_color_int': '',
          'series_color_ext_code': '',
          'series_color_int_code': '',
          'series_accessories_name': ''
        }
      }
    },

    getTemplateContext: function () {
      return $.extend({}, this.staticData.all, this.staticData[this.getCanvas().getLang()], this.getConfig().data);
    }
  }, {
    configurable: false,
  });

  return CamryStaticModule;
});

